export enum ETimeSlot {
    AM = "Morning (8:30 to 13:30)",
    PM = "Afternoon (13:30 to 17:30)",
    AD = "All day (8:30 to 17:30)",
}

export interface IAvailableAppointmentDate {
    scheduledDate: string;
    timeSlotList: ETimeSlot[];
}
